var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "11",
      "height": "7"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "gray",
      "fill-rule": "evenodd",
      "d": "m.87.55 5.095 6.182L11.058.55z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }